module.exports = __webpack_public_path__ + "static/media/image-polaroid.b772aaf1.svg";